module.exports = __webpack_public_path__ + "img/ico_badge09.1753e440.svg";